import React, {Component} from 'react';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import {ROLES, withRoles} from "../../Permissions";
import {withStyles} from "@material-ui/core/styles/index";
import _ from 'lodash';
import List from '@material-ui/core/List';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemText from '@material-ui/core/ListItemText';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-auto-tabpanel-${index}`}
            aria-labelledby={`scrollable-auto-tab-${index}`}
            {...other}
        >
            <Box p={3}>{children}</Box>
        </Typography>
    );
}

const styles = theme => ({
    root: {
        flexGrow: 1,
        width: '100%',
        backgroundColor: theme.palette.background.paper,
    },
    courseList: {
        maxHeight: 400, 
        overflowY: 'auto',
    },
});

function a11yProps(index) {
    return {
        id: `scrollable-auto-tab-${index}`,
        'aria-controls': `scrollable-auto-tabpanel-${index}`,
    };
}

class EmphasisTab extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: 0,
            selected: null,
            query: ''
        };
        this.handleChange = this.handleChange.bind(this);
    };

    handleToggle = course => () => {
        this.setState({selected: course.id})
        this.props.handleToggle(course);
    };

    renderCourseList(list, emphasisTitle) {
        const { selected } = this.state;
        return _.map(list, option => {
            return (
                <MenuItem button selected={selected === option.id} key={option.id + '-' + emphasisTitle} data-id={option.id} data-code={option.code} data-title={option.title} data-outcomes={JSON.stringify(option.outcomes)} value={option.code} style={{width:'100'}}  onClick={this.handleToggle(option)}>
                    <ListItemText id={option.name} primary={option.code + ' - ' + option.title} />
                </MenuItem>
            );
        });

    }

    renderTabs() {
        let index = 1;
        return _.map(this.props.emphases, option => {
            return (
                <Tab label={option.title + ' emphasis'} {...a11yProps(index++)} onClick={() => this.handleSwitchTabs(option.pid)} />
            );
        });
    }

    renderTabPanels() {
        let index = 1;
        return _.map(this.props.emphases, option => {
            return (
                <TabPanel value={this.state.value} index={index++}>
                    <List className={this.props.classes.courseList}>
                        {this.renderCourseList(option.requiredCourses, option.title)}
                    </List>
                </TabPanel>
            );
        });
    }

    handleChange(event, newValue) {
        this.setState({value: newValue});
    }

    handleSwitchTabs = (optionpid) => {
        this.setState({
            selected: null
        })
        this.props.handleSwitchTabs(optionpid);
    }

    render() {
        const { classes } = this.props;
        return (

            <div className={classes.root}>

                <AppBar position="static" color="default">
                    <Tabs
                        value={this.state.value}
                        onChange={this.handleChange}
                        indicatorColor="primary"
                        textColor="primary"
                        variant="scrollable"
                        scrollButtons="auto"
                        aria-label="scrollable auto tabs example"
                    >
                        <Tab label='Program Required Courses' {...a11yProps(0)} onClick={() => this.handleSwitchTabs('RequiredCourses')}/>
                        {/*<Tab label='Ad Hoc Courses' {...a11yProps(1)} onClick={() => this.handleSwitchTabs()}/>*/}

                        {this.renderTabs()}
                    </Tabs>
                </AppBar>
                <TabPanel value={this.state.value} index={0}>
                    <List className={this.props.classes.courseList}>
                        {this.renderCourseList(this.props.courses)}
                    </List>
                </TabPanel>

                {/*<TabPanel value={this.state.value} index={1}>*/}
                    {/*<Adhoc handleToggle={this.props.handleToggle}/>*/}
                {/*</TabPanel>*/}
                {this.renderTabPanels()}
            </div>
        );
    }
}

export default (withStyles(styles))(withRoles([ROLES.COORDINATOR, ROLES.ADMIN, ROLES.DEPARTMENTCOORDINATOR])(EmphasisTab));
